var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuliusbaerBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484,
    height: 441,
    viewBox: "0 0 484 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8736_32623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3179 116.035V113.236L6.39062 109.477L225.436 9.06348L477.948 124.806L472.825 128.148V130.737",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.681 384.486L472.827 423.374L225.438 441",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.827 375.381V335.115L483.999 329.476V324.464L225.438 297.355",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.828 315.15V323.295",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.438 46.4873L472.827 148.571",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.999 140.803L225.438 28.3604",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.391 21.0088L484.001 135.749V140.803L472.829 148.572V226.347",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3182 332.4L0 326.302V320.997L225.436 297.355",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.997 329.476L225.436 304.707L0 326.302",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.438 190.467L236.073 192.931L242.854 191.762L477.706 247.983V242.971L483.999 234.575V229.605L242.854 163.192L236.073 164.821L225.438 161.938",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.438 183.533L236.073 186.165L242.951 184.661L477.706 242.971",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.438 169.081L236.073 171.88L242.854 170.376L483.999 234.575",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.592 22.8476L288.467 11.4863L258.172 23.9753",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.461 4.76172L315.195 18.2114",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.148 20.8423L288.469 4.76107L302.129 0.25L315.203 18.2108L311.593 22.8472V48.5353",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.461 37.9683V4.76172",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.031 40.8906L327.687 30.8242L311.734 36.9225",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.641 24.4346L351.789 36.6312",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.734 30.6997L327.638 24.4343L340.566 20.1738L351.787 36.6309L348.031 40.8914L348.128 65.3264",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.641 24.4346L327.787 55.9286",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.762 58.0592L362.663 48.1182L348.125 53.5064",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.125 47.5351L362.663 42.0633L376.079 37.6357L385.592 53.5916L382.762 58.0609V81.2011",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.593 53.5888L362.664 42.0605",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.664 42.0605V71.9673",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.289 73.5971L395.165 64.1572L382.969 68.1253",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.156 58.3525L416.817 69.2961",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.969 62.4029L393.897 58.8108L407.703 53.5479L416.826 69.2949L414.289 73.5971V95.6513",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.156 58.3525V86.881",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.825 87.7144L425.311 79.0264L414.383 82.2844",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.258 73.3867L445.211 83.5367",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.383 76.8555L424.189 73.8481L436.922 68.627L445.215 83.5386L442.825 87.7155V108.684",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.258 73.3867V100.62",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.766 22.5976L162.89 11.2363L193.185 23.7253",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.898 4.50977L136.164 17.9595",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.024 20.5087L162.898 4.51109L149.238 0L136.164 17.9608L139.774 22.5972V48.2853",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.891 4.50977V37.5075",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.328 40.6406L123.672 30.5742L139.771 36.7143",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.229 65.0754L103.327 40.6404L99.5703 36.38L110.791 19.9229L123.768 24.1833L139.769 30.4905",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.768 24.1855L99.5703 36.3822",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.765 24.1846L123.57 55.6786",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5938 57.8073L88.6932 47.8662L103.231 53.2545",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.233 47.2841L88.6947 41.8123L75.2788 37.3848L65.7656 53.3406L68.5952 57.8099V80.9501",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7656 53.3389L88.6947 41.8105",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6875 41.8105V71.7174",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0781 73.3471L56.2019 63.9072L68.447 67.9171",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2056 58.1406L34.5938 69.0006",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0778 95.4003V73.3461L34.4922 69.0439L43.6638 53.2969L56.2016 58.1003L68.4466 62.1938",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2031 86.6273V58.1406",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.391 110.312L253.098 108.6L278.857 117.664",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.609 96.2365L272.27 103.379V74.4747L252.609 66.6221",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.27 171.212V133.369L252.609 126.979",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.594 126.309L298.96 124.722L323.255 133.243",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.562 112.902L317.052 119.585V92.3931L298.562 85",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.052 183.576V147.946L298.562 141.932",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.617 141.012L341.642 139.508L364.522 147.528",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.297 128.397L358.713 134.704V109.141L341.297 102.166",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.713 195.104V161.438L341.297 155.799",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.281 154.63L381.062 153.21L402.576 160.77",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.719 142.85L397.111 148.782V124.681L380.719 118.123",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.403 205.547L397.111 173.886L380.719 168.539",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.672 167.161L417.209 165.824L437.552 172.967",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.867 155.841L432.381 161.564V138.674L416.867 132.492",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.381 215.403V185.329L416.867 180.275",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.484 178.856L450.777 177.603L469.072 184.035",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.43 168.164L465.212 173.51V151.874L450.43 145.984",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.212 224.218V196.023L450.43 191.262",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.828 285.034V203.083",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.883 200.659V283.78",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.928 366.44C279.928 362.263 282.904 334.862 263.438 334.862C245.339 334.862 246.851 359.673 246.851 365.145V439.369",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.922 437.158V385.071",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.859 224.551C246.859 224.551 249.591 213.232 260.666 214.025C273.838 214.986 273.935 228.06 273.935 228.06V282.986",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.469 290.337V212.771",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.055 210.477V289.086",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.688 232.446C289.688 232.446 292.127 222.088 302.664 222.881C315.105 223.8 315.202 236.164 315.202 236.164V288.375",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.062 295.35V222.003",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.133 219.873V294.055",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.469 241.092C330.469 241.092 332.908 230.9 342.86 231.652C354.666 232.529 354.764 244.183 354.764 244.183V293.345",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.648 300.028V230.732",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.211 228.728V299.067",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.109 248.693C369.109 248.693 371.451 239.045 380.867 239.713C392.038 240.548 392.136 251.659 392.136 251.659V298.399",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.094 304.583V239.005",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.141 237.083V303.538",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.648 256.044C405.648 256.044 407.844 246.939 416.723 247.691C427.26 248.484 427.309 258.927 427.309 258.927V303.035",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.672 308.842V246.814",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.172 244.975V307.837",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.094 262.771C440.094 262.771 442.143 254.125 450.583 254.751C460.34 255.503 460.632 265.402 460.632 265.402V307.172",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.859 192.764V279.477",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.07 192.932V278.057",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.5 375.59V374.504L395.6 374.922V428.929",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.258 430.682L371.453 384.819",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.328 364.896L398.721 365.647",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.202 336.367C387.641 336.367 391.3 341.338 391.3 347.854C391.3 354.37 387.641 359.716 383.202 359.8C378.763 359.883 375.25 354.746 375.25 348.355C375.25 341.964 378.811 336.576 383.202 336.367Z",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.855 385.112V379.222L279.828 366.441L246.898 365.647L267.144 378.972V385.154L298.855 385.112Z",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 341.715C259.781 345.892 259.733 365.941 259.733 365.941",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.688 385.071V436.448",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.203 367.234C321.203 363.391 324.081 337.202 305.64 337.202C288.419 337.202 289.882 360.76 289.882 365.981V373.165",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.25 434.234V385.071",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.244 384.945V379.348L321.193 367.193L289.922 366.441L309.094 379.097V385.029L339.244 384.945Z",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.781 343.72C302.172 347.897 302.075 366.776 302.075 366.776",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.57 385.071V433.774",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.329 368.112C360.329 364.478 363.012 339.792 345.693 339.792C329.35 339.792 330.765 362.139 330.765 367.109V373.5",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.328 431.476V384.819",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.398 384.737V379.557L360.323 368.071L330.516 367.402L348.81 379.39V384.862L377.398 384.737Z",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.273 345.975C342.225 349.901 342.079 367.695 342.079 367.695",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.477 369.66C432.477 366.402 434.916 344.139 419.159 344.139C404.523 344.139 405.694 364.23 405.694 368.699V428.262",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.484 426.338V384.568",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.853 384.57V379.892L432.486 369.659L405.703 369.032L422.144 379.767V384.612L447.853 384.57Z",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.141 384.651V425.794",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.312 370.367C465.312 367.318 467.556 346.35 452.725 346.35C438.87 346.35 440.09 365.271 440.09 369.49V374.753",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.312 424V384.528",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.803 384.484V380.057L465.314 370.366L440.141 369.781L455.606 379.931V384.526L479.803 384.484Z",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3203 217.284V134.831L225.438 46.4473",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3203 304.539V238.878",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3203 319.828V311.182",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3203 374.544V332.398",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3203 384.736V425.754L225.438 441",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.09375 126.309L225.432 28.3604",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.384 21.0088L0.09375 121.004V126.309L11.3143 134.83",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.39 314.397L11.3203 332.4",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.436 183.533L214.898 186.123L208.068 184.619L6.39062 234.701V240.047L208.068 191.762L214.85 192.931L225.436 190.467",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.432 161.938L214.895 164.821L208.065 163.192L0.09375 220.374V225.72L6.38702 234.701",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.432 169.081L214.846 171.88L208.065 170.334L0.09375 225.72",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07 110.186L198.362 108.516L172.555 117.538",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.754 66.3281L179.094 74.1807V103.127L198.754 95.9425",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.094 171.003V133.16L198.754 126.77",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.818 125.975L152.402 124.43L128.156 132.909",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.794 84.7061L134.305 92.0992V119.458L152.794 112.775",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.305 183.325V147.737L152.794 141.723",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.741 140.636L109.716 139.341L86.8359 147.319",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.057 101.793L92.6406 108.768V134.624L110.057 128.275",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6406 194.853V161.27L110.057 155.59",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0842 154.253L70.3033 153.083L48.7891 160.601",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.589 117.662L54.1484 124.22L54.246 148.571L70.589 142.64",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.25 205.336V173.759L70.6906 168.412",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6809 166.825L34.339 165.572L15.7031 172.13",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4902 132.241L18.9766 138.423V161.396L34.4902 155.757",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9766 215.028V185.163L34.4902 180.109",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.578 284.989V202.954",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.484 200.535V283.698",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.476 366.358C171.476 362.181 168.5 334.822 187.965 334.822C206.064 334.822 204.552 359.591 204.552 365.105V439.371",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.484 437.199V385.071",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.56 224.509C204.56 224.509 201.828 213.148 190.754 213.983C177.582 214.944 177.484 227.976 177.484 227.976V282.944",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.938 290.256V212.648",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.352 210.434V289.043",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.577 232.279C161.577 232.279 159.138 222.045 148.6 222.797C136.16 223.716 136.062 236.122 136.062 236.122V288.333",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2969 295.309V221.879",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2344 219.746V294.137",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.936 241.049C120.936 241.049 118.496 230.858 108.544 231.568C96.7382 232.445 96.6406 244.098 96.6406 244.098V293.386",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7109 300.069V230.732",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1484 228.602V298.983",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3 248.653C82.3 248.653 79.9096 238.879 70.5428 239.673C59.371 240.508 59.2734 251.619 59.2734 251.619V298.359",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2734 237.04V303.537",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7622 256.003C45.7622 256.003 43.5669 246.898 34.688 247.65C24.1504 248.401 24.1016 258.886 24.1016 258.886V302.91",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.508 192.641V279.395",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.898 192.932V278.057",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.547 385.027V379.18L171.476 366.315L204.503 365.604L184.257 378.929V385.111L152.547 385.027Z",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.412 341.631C191.631 346.058 191.68 365.899 191.68 365.899",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.531 385.071V436.489",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.156 367.236C130.156 363.393 127.326 337.162 145.767 337.162C163.037 337.162 161.525 360.72 161.525 365.941V373.125",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.156 434.234V385.071",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.109 384.903V379.306L130.111 367.235L161.529 366.566L142.259 379.222V384.945L112.109 384.903Z",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.622 343.635C149.279 347.812 149.328 366.817 149.328 366.817",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.836 385.071V433.691",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0877 368.112C91.0877 364.478 88.4045 339.751 105.723 339.751C122.066 339.751 120.651 362.098 120.651 367.068V373.459",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0781 431.477V385.071",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9609 384.862V379.557L91.0357 368.071L120.843 367.444L102.549 379.432V384.904L73.9609 384.862Z",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.136 345.891C109.184 349.859 109.281 367.694 109.281 367.694",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7578 384.78V428.22",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9332 369.699C18.9332 366.4 16.494 344.095 32.2516 344.095C46.8871 344.095 45.7162 364.186 45.7162 368.655V374.628",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9297 426.338V384.568",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 384.694V379.932L18.9298 369.657L45.6641 369.072L29.2723 379.849V384.736L3.5625 384.694Z",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1562 385.071V431.017",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1958 368.906C54.1958 365.481 51.6589 342.09 68.0995 342.09C83.4669 342.09 82.1496 362.974 82.1496 367.736V374.085",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2031 428.844V384.819",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1484 384.778V379.766L54.15 368.906L82.1526 368.279L64.9803 379.599V384.82L38.1484 384.778Z",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.391 285.701L477.707 315.733V309.509L225.439 276.679",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.387 285.701L6.39062 311.765V305.207L225.436 276.679",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.195 151.663L225.438 148.238L219.438 149.951",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.336 135.538L225.433 133.784L213.578 137.167",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.195 122.926L225.438 119.167L219.438 121.088",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.389 106.638L225.437 104.633L213.68 108.517",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.293 94.3552L225.389 90.0947L219.438 92.1832",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.389 77.7333L225.437 75.5195L213.68 79.9053",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.293 65.6613L225.438 60.9414L219.438 63.3223",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.438 440.874V9.06348",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.829 335.115L225.391 314.397",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.025 172.841V178.313L246.609 185.58",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.161 177.102V182.573L262.844 189.632",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.687 181.236V186.416L278.516 193.516",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.908 185.287V190.383L293.883 197.317",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.644 189.216V194.228L308.766 200.995",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.887 193.059V197.904L323.203 204.587",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.935 196.817V201.496L337.203 208.095",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.498 200.369V205.047L350.961 211.48",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.766 203.916V208.636L364.375 214.818",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.647 207.344V211.897L377.305 218.037",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.182 210.684V215.236L389.938 221.168",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.432 213.941V218.452L402.383 224.217",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.332 217.116V221.377L414.234 227.224",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.998 220.208V224.468L426.047 230.149",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.458 223.258V227.477L437.555 232.99",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.532 226.223V230.274L448.727 235.663",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.458 229.145V233.196L459.945 238.417",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.001 231.943V236.12L470.586 241.174",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.807 42.0605V49.7461L250.758 56.8051",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.684 34.627V42.0201L233.195 49.5804",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.243 49.2461V56.8064L267.438 63.6983",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.712 55.9297V63.3228L282.906 70.1312",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.927 62.5693V69.6701L298.219 76.395",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.858 69.043V76.0602L313.297 82.5762",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.155 75.2676V82.3266L327.789 88.6755",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.253 81.4062V88.2146L341.984 94.4382",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.812 87.2979V94.3151L355.836 100.205",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.37 93.1865V99.7861L369.297 105.717",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.211 98.7422V105.551L382.43 111.148",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.984 104.338V110.812L395.203 116.409",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.23 109.644V115.867L407.547 121.464",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.144 114.82V121.127L419.656 126.474",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.143 120.042V126.224L431.703 131.487",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.359 124.933V130.571L442.773 136.001",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.586 129.775V135.707L454.391 140.802",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.602 134.58V140.344L465.406 145.357",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.797 172.799V178.312L204.261 185.58",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.703 177.101V182.572L187.972 189.631",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.141 181.236V186.416L172.361 193.516",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.914 185.287V190.383L156.988 197.317",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.234 189.216V194.228L142.113 200.995",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.984 193.059V197.904L127.619 204.587",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.938 196.817V201.496L113.67 208.095",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3281 200.368V205.046L99.9139 211.479",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1094 203.916V208.636L86.4512 214.818",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2266 207.344V211.897L73.5684 218.037",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6875 210.643V215.237L60.883 221.168",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3984 213.941V218.452L48.4964 224.217",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4844 217.116V221.377L36.6311 227.224",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8281 220.208V224.468L24.8285 230.149",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41406 223.258V227.477L13.3169 232.99",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.016 42.1035V49.7473L200.016 56.7645",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.188 34.668V42.0194L217.53 49.4543",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.578 49.2021V56.8042L183.335 63.6125",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.156 55.8857V63.3207L167.815 70.0037",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.891 62.5293V69.6719L152.55 76.3132",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.016 69.002V76.061L137.48 82.5352",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.672 75.2275V82.3283L123.087 88.6773",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.57 81.4062V88.2146L108.79 94.3965",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0078 87.2559V94.3148L94.9351 100.079",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4922 93.1475V99.7888L81.5171 105.678",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6562 98.6992V105.549L68.3884 111.105",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8906 104.299V110.815L55.574 116.328",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5938 109.603V115.868L43.3259 121.423",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7344 114.781V121.13L31.1738 126.435",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7344 120.002V126.226L19.125 131.447",
    stroke: "#E8E9EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8736_32623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 484.001,
    height: 441,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuliusbaerBuilding);
export default __webpack_public_path__ + "static/media/juliusbaer-building.f621dba3dc32ce4cc5f63b006603ef7e.svg";
export { ForwardRef as ReactComponent };